import React, {Suspense, useEffect} from 'react';
import {Route, Routes, useLocation} from "react-router-dom";
import {checkNullJson, isValueBool} from "../common/fusion-ui/utils/ReactUtils";
import getAdminRoutes from "./adminRoutes";
import {isCurrUrlOfAuthRoute} from "./utils/AdminUtils";
import {clearUserSessionData} from "../app/utils/AppUtils";
import {Toast} from "../common/fusion-ui";
import {useSelector} from "react-redux";
import {StyledEngineProvider} from "@mui/system";
import {ThemeProvider} from "@mui/styles";
import CssBaseline from "@mui/material/CssBaseline";
import themes from "./themes";
import "../common/assets/css/ThemeStyles_RoyalBlue.css";

// ==============================|| APP ||============================== //

export default function App() {
    const location = useLocation();
    const customization = useSelector((state) => state.customization);
    useEffect(() => {
        //Clear user-session data
        clearUserSessionData(null, true);
    }, []);
    return (<>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={themes(customization)}>
                    <CssBaseline/>
                    {/*<Suspense fallback={<CircleLoading label={'Loading...'}/>}>*/}
                    <Suspense>
                        <Routes>
                            {getAdminRoutes(isCurrUrlOfAuthRoute(location)).map((item, index) => {
                                return (checkNullJson(item) && !isValueBool(item)) &&
                                    <Route key={item.route} exact path={item.route} element={item.component}/>
                            })}
                        </Routes>
                    </Suspense>

                    {/*<FAB  icon={<Icon className={'fs-normal'} icon={IconClass.bookmark}/>}*/}
                    {/*    onClick={() => console.log('FAB Clicked')}/>*/}
                </ThemeProvider>
            </StyledEngineProvider>
            <Toast/>
        </>
    );
};
